import { mergeWith } from 'lodash-es';
import localPageConfigPresets from './pageConfigPresets.json';
import type { RawConfigData } from './type';

export const withLocalPageConfigPresets = (data: RawConfigData): RawConfigData =>
	mergeWith({}, { pageConfigPresets: localPageConfigPresets }, data, (_objValue, srcValue) => {
		if (Array.isArray(srcValue)) {
			return srcValue;
		}

		return undefined;
	});
